import React from 'react';
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Company(props) {
    const [companyInfo, setCompanyInfo] = useState({
        addr1: '',
        addr2: '',
        phone1: '',
        email: '',
        phone2: '',phlink:'',
        sreg_no: ''
    });

    const fetchData = () => {
        fetch('https://singlewindowsecurities.com/rest3/company_profile_api')
            .then((response) => response.json())
            .then((data) => {
                setCompanyInfo({
                    addr1: data.head_office || '',
                    addr2: data.branch_office || '',
                    phone1: data.phone1 || '',
                    email: data.email || '',
                    phone2: data.phone2 || '',
                    phlink: data.phlink || '',
                    sreg_no: data.sreg_no || ''
                });
            });
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="safearea" style={{ 
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
        }}>
            <Helmet>
                <title>About Company | Single Window Securities</title>
            </Helmet>

            {/* Modern Header */}
            <div style={{
                background: 'rgba(10, 10, 10, 0.95)',
                backdropFilter: 'blur(10px)',
                borderBottom: '1px solid rgba(212, 175, 55, 0.3)',
                position: 'sticky',
                top: 0,
                zIndex: 100
            }}>
                <div className="container">
                    <div className="d-flex align-items-center py-3">
                        <Link to="/settings" className="btn me-2" style={{
                            background: 'rgba(212, 175, 55, 0.1)',
                            border: '1px solid rgba(212, 175, 55, 0.3)',
                            borderRadius: '12px',
                            width: '36px',
                            height: '36px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#D4AF37'
                        }}>
                            <i className="fa fa-arrow-left"></i>
                        </Link>
                        <h1 className="h5 mb-0 fw-bold" style={{ color: '#D4AF37' }}>About Company</h1>
                    </div>
                </div>
            </div>

            <main className="container py-4">
                <div style={{
                    background: 'rgba(20, 20, 20, 0.95)',
                    borderRadius: '24px',
                    border: '1px solid rgba(212, 175, 55, 0.2)',
                    overflow: 'hidden'
                }}>
                    <div className="p-4">
                        <div className="text-center mb-4">
                            <div style={{
                                width: '70px',
                                height: '70px',
                                background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                                borderRadius: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 16px'
                            }}>
                                <i className="fa fa-building" style={{ color: '#000', fontSize: '32px' }}></i>
                            </div>
                            <h2 className="fw-bold mb-2" style={{ color: '#D4AF37' }}>SingleWindow Securities</h2>
                            <div style={{
                                width: '60px',
                                height: '2px',
                                background: 'linear-gradient(90deg, #D4AF37, transparent)',
                                margin: '0 auto'
                            }}></div>
                        </div>

                        <div className="company-info">
                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-building" style={{ color: '#D4AF37', fontSize: '18px', marginRight: '12px', width: '24px' }}></i>
                                    <h3 className="h6 fw-bold mb-0" style={{ color: '#D4AF37', letterSpacing: '1px' }}>HEAD OFFICE</h3>
                                </div>
                                <p className="ms-4" style={{ color: '#888', lineHeight: '1.6' }}>{companyInfo.addr1 || 'Loading...'}</p>
                            </div>

                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-code-branch" style={{ color: '#D4AF37', fontSize: '18px', marginRight: '12px', width: '24px' }}></i>
                                    <h3 className="h6 fw-bold mb-0" style={{ color: '#D4AF37', letterSpacing: '1px' }}>BRANCH OFFICE</h3>
                                </div>
                                <p className="ms-4" style={{ color: '#888', lineHeight: '1.6' }}>{companyInfo.addr2 || 'Loading...'}</p>
                            </div>

                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-envelope" style={{ color: '#D4AF37', fontSize: '18px', marginRight: '12px', width: '24px' }}></i>
                                    <h3 className="h6 fw-bold mb-0" style={{ color: '#D4AF37', letterSpacing: '1px' }}>EMAIL</h3>
                                </div>
                                <p className="ms-4" style={{ color: '#D4AF37' }}>{companyInfo.email || 'Loading...'}</p>
                            </div>

                            <div className="mb-4">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-phone" style={{ color: '#D4AF37', fontSize: '18px', marginRight: '12px', width: '24px' }}></i>
                                    <h3 className="h6 fw-bold mb-0" style={{ color: '#D4AF37', letterSpacing: '1px' }}>PHONE</h3>
                                </div>
                                <div className="ms-4">
                                    <a href={companyInfo.phlink} target='_blank' className="mb-1" style={{ color: '#D4AF37' }}>{companyInfo.phone1 || 'Loading...'}</a>
                                    {companyInfo.phone2 && <p className="mb-0" style={{ color: '#D4AF37' }}>{companyInfo.phone2}</p>}
                                </div>
                            </div>

                            {companyInfo.sreg_no && (
                                <div className="mb-4">
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-registered" style={{ color: '#D4AF37', fontSize: '18px', marginRight: '12px', width: '24px' }}></i>
                                        <h3 className="h6 fw-bold mb-0" style={{ color: '#D4AF37', letterSpacing: '1px' }}>SEBI REGISTRATION NO</h3>
                                    </div>
                                    <p className="ms-4" style={{ color: '#888' }}>{companyInfo.sreg_no}</p>
                                </div>
                            )}
                        </div>

                        <div className="text-center mt-4 pt-2" style={{ borderTop: '1px solid rgba(212, 175, 55, 0.1)' }}>
                            <Link to="/contact" className="btn" style={{
                                background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                                border: 'none',
                                borderRadius: '30px',
                                color: '#000',
                                fontWeight: 'bold',
                                padding: '10px 30px',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 5px 20px rgba(212, 175, 55, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}>
                                Contact Us
                            </Link>
                        </div>
                    </div>
                </div>

            </main>
        </div>
    );
}